var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMosaicHooterOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.798,
    height: 50.239,
    viewBox: "0 0 49.798 50.239",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3328",
    "data-name": "Group 3328",
    transform: "translate(-52.153 -4.901)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1180",
    "data-name": "Path 1180",
    d: "M86.23,25.29a1,1,0,0,0,1-1c0-6.669-6.546-9.564-10.008-10.163a1,1,0,0,0-.343,1.97c.341.06,8.351,1.547,8.351,8.193a1,1,0,0,0,1,1",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1181",
    "data-name": "Path 1181",
    d: "M86.308,28.137a1,1,0,0,0-1,1V39.66a1,1,0,0,0,2,0V29.137a1,1,0,0,0-1-1",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1182",
    "data-name": "Path 1182",
    d: "M94.88,53.14H56.611a1,1,0,1,0,0,2H94.88a1,1,0,0,0,0-2",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1183",
    "data-name": "Path 1183",
    d: "M101.682,5.219a1,1,0,0,0-1.413-.048L89.688,15.059a17.83,17.83,0,0,0-32.15,10.309c0,.131.009.259.018.387l.013.105-.011.168c-.011.146-.02.292-.02.442V45.107l-5.067,4.736A1,1,0,0,0,53.836,51.3l3.7-3.46v2.79H93.127V26.47c0-.165-.011-.327-.023-.488l-.007-.037.012-.19c.009-.128.018-.256.018-.387a17.186,17.186,0,0,0-2.32-8.618L101.633,6.632a1,1,0,0,0,.049-1.413M59.551,25.607c-.006-.079-.013-.158-.013-.239a15.677,15.677,0,0,1,15.8-15.52,15.858,15.858,0,0,1,12.889,6.581L60.242,42.58h-.7V26.47c0-.1.008-.2.015-.3l.014-.287c0-.092-.009-.183-.016-.274m-.013,23.027v-2.66L61.03,44.58h30.1v4.054ZM91.127,25.368c0,.081-.008.16-.013.239s-.013.182-.014.369l.01.148c.008.115.017.229.017.346V42.58H63.17L89.305,18.154a15.2,15.2,0,0,1,1.822,7.214",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMosaicHooterOff);
export default __webpack_public_path__ + "static/media/MosaicHooterOff.66a787e1c6e7f4bd346227abb5d3567b.svg";
export { ForwardRef as ReactComponent };